(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("customerDetails", {
            parent: "app",
            url: "/customer/details/:id",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl: "app/customer/details/customer.details.html",
                    controller: "CustomerDetailsController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
